import palette from "layouts/ThemeProvider/palette";

const HEX_TRANSPARENCY = "26";

const buttonDefault = {
  height: 40,
  fontSize: 15,
  padding: "0px 30px",
  borderWidth: 1.5,
  borderRadius: 20,
  textTransform: "none",
  "&:disabled": {
    background: `#000000${HEX_TRANSPARENCY}`,
    color: palette.dustyGray,
  },
};

const outlinedDefaultDisable = {
  "&:disabled": {
    borderColor: `${palette.dustyGray}${HEX_TRANSPARENCY}`,
    background: "white",
    color: palette.dustyGray,
  },
};

const hoverTransform = {
  transition: "transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
  "&:hover": {
    "@media (hover: hover)": {
      transform: "scale(1.1)",
    },
  },
};

const fullDefault = {
  ...buttonDefault,
  ...hoverTransform,
};

const fullDefaultOutlined = {
  ...fullDefault,
  ...outlinedDefaultDisable,
};

const outlinedDefault = (color) => {
  return {
    borderColor: color,
    color,
    "&:hover": {
      background: color,
      color: "white",
    },
  };
};

const containedDefault = (color) => {
  return {
    background: color,
  };
};

const textDefault = (color) => {
  return {
    borderRadius: 18,
    "&:hover": {
      "@media (hover: hover)": {
        background: `${color}${HEX_TRANSPARENCY}`,
      },
    },
  };
};

export default {
  MuiButton: {
    defaultProps: {
      disableRipple: true,
      disableFocusRipple: true,
      disableTouchRipple: true,
      disableElevation: true,
    },
    styleOverrides: {
      outlined: fullDefaultOutlined,
      outlinedDark: outlinedDefault(palette.dark.main),
      outlinedPrimary: outlinedDefault(palette.primary.main),
      outlinedPrimaryLight: outlinedDefault(palette.primary.light),
      outlinedSecondary: outlinedDefault(palette.secondary.main),
      outlinedSecondaryLight: outlinedDefault(palette.secondary.light),
      outlinedWarning: outlinedDefault(palette.warning.main),
      outlinedDelete: outlinedDefault(palette.delete.main),
      outlinedSuccess: outlinedDefault(palette.success.main),
      contained: fullDefault,
      containedDark: containedDefault(palette.dark.main),
      containedPrimary: containedDefault(palette.primary.main),
      containedPrimaryLight: containedDefault(palette.primary.light),
      containedPrimaryGradient: containedDefault(palette.primary.gradient),
      containedSecondary: containedDefault(palette.secondary.main),
      containedSecondaryLight: containedDefault(palette.secondary.light),
      containedSecondaryGradient: containedDefault(palette.secondary.gradient),
      textPrimary: textDefault(palette.primary.main),
      textSecondary: textDefault(palette.secondary.main),
      textDelete: textDefault(palette.delete.main),
      textWarning: textDefault(palette.warning.main),
      textSuccess: textDefault(palette.success.main),
      textPrimaryLight: textDefault(palette.primary.light),
      textSecondaryLight: textDefault(palette.secondary.light),
      textDark: textDefault(palette.dark.main),
      sizeXsmall: {
        height: 26,
        fontSize: 12,
        padding: "6px 5px",
      },
      sizeLarge: {
        height: 60,
        borderRadius: 30,
        borderWidth: 2,
        fontSize: 20,
        padding: "0px 34px",
      },
    },
  },
};
